import React, { memo } from 'react';
import styles from './styles.module.scss';
import { IEmailTemplate } from './useSendPurchaseOrder';
import { LanguageSelect, SunTextEditor } from 'components';
import { Row, Col, Form, Input, Select, Typography } from 'components';

const { Title } = Typography;

interface EmailFormProps {
  form: any;
  contactPersons: any[];
  currentUser: any;
  supplierId: string;
  emailTemplate: IEmailTemplate;
  handleContactPersonChange: (value: string) => void;
  onLanguageChange: (value: string) => void;
  handleEmailTemplateChange: (value: string, key: 'subject' | 'content') => void;
}

export const EmailForm: React.FC<EmailFormProps> = memo(
  ({
    form,
    contactPersons,
    currentUser,
    emailTemplate,
    handleContactPersonChange,
    onLanguageChange,
    handleEmailTemplateChange,
  }) => {
    return (
      <Form style={{ marginTop: 20 }} form={form} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="Contact Person" name="contactPersonId">
              <Select
                size="large"
                placeholder="Select contact person"
                onChange={handleContactPersonChange}
                options={contactPersons}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Language" name="languageId">
              <LanguageSelect size="large" onChange={onLanguageChange} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Title level={5} className={styles.sectionTitle}>
              Email
            </Title>
          </Col>
          <Col span={12}>
            <Form.Item label="From" name="from" initialValue={currentUser?.email}>
              <Input disabled size="large" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Subject" name="subject" initialValue={emailTemplate.subject}>
              <Input
                size="large"
                placeholder="Enter email subject"
                value={emailTemplate.subject}
                onChange={(e) => handleEmailTemplateChange(e.target.value, 'subject')}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <div className={styles.emailLabel}>Email Body</div>
            <SunTextEditor
              value={emailTemplate.content}
              onChange={(value: string) => handleEmailTemplateChange(value, 'content')}
            />
          </Col>
        </Row>
      </Form>
    );
  }
);
